'use strict';

var React = require('react');
var Theme = require('../../Theme/Theme.js');
require('../../Theme/DarkTheme.js');
require('../../Theme/LightTheme.js');
var ThemeProvider = require('../../node_modules/@material-ui/styles/esm/ThemeProvider/ThemeProvider.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function HousecallThemeProvider(_ref) {
  var children = _ref.children;
  return React__default["default"].createElement(ThemeProvider, {
    theme: Theme.theme
  }, children);
}

module.exports = HousecallThemeProvider;
